import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer style={{ 
      background: '#004080', 
      color: 'white', 
      padding: '48px 24px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative'
    }}>
      <div className="footer-content" style={{ 
        maxWidth: '1200px', 
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        {/* Logo and Tagline */}
        <div style={{ flex: '1 1 300px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '12px' }}>Connection Health Care</h2>
          <img 
            src="ConnectionHealthLogoTransparent.png" 
            alt="Connection Health Care Logo" 
            style={{ 
              height: '250px', 
              width: 'auto',
            }} 
          />
        </div>

        {/* Quick Links */}
        <div style={{ flex: '1 1 200px' }}>
          <h3 style={{ fontSize: '18px', marginBottom: '16px' }}>Explore</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '8px' }}><Link to="/" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Home</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/services" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Services</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/bookingform" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Book Now</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/aboutus" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>About Us</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/ourteam" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Our Team</Link></li>
            <li style={{ marginBottom: '8px' }}><Link to="/career" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Careers</Link></li>
            <li style={{ marginBottom: '8px' }}><a href="#contact-form" style={{ color: 'white', textDecoration: 'none' }}>Contact</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div style={{ flex: '1 1 300px' }}>
          <h3 style={{ fontSize: '18px', marginBottom: '16px' }}>Contact Us</h3>
          <p style={{ marginBottom: '8px' }}>Email: info@connectionhealthcare.ca</p>
          <p style={{ marginBottom: '8px' }}>Tel: 905-597-1892 </p>
          <p style={{ marginBottom: '8px' }}>Fax: 905-948-1891 </p>
          <p style={{ marginBottom: '8px' }}>Available 24 hours</p>
          <a href="https://maps.app.goo.gl/ZLopD6iwB52QdmmX7" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>
            <p style={{ marginBottom: '8px' }}>1 West Pearce St. Suite 201, Richmond Hill, ON L4B 3K3</p>
          </a>
        </div>
      </div>

      {/* Policy Links */}
      <div style={{ 
        display: 'flex',
        justifyContent: 'center',
        gap: '24px',
        width: '100%',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        marginTop: '24px',
        paddingTop: '16px'
      }}>
        <Link to="/privacy-policy" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>
        <Link to="/accessibility" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Accessibility Policy</Link>
        {/* <Link to="/bill-of-rights" style={{ color: 'white', textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>Bill of Rights</Link> */}
      </div>

      {/* Copyright */}
      <div style={{ 
        marginTop: '16px',
        width: '100%',
        textAlign: 'center'
      }}>
        <p>&copy; 2025 Connection Health Care - All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
